// extracted by mini-css-extract-plugin
export default {"base":"components-Shared-Form-formError__base--pYH09","rotWarning":"components-Shared-Form-formError__rotWarning--pAUXI"};